import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";

const Projects = () => {
  const collageImages = [
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605461/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605461845.jpg",
      alt: "Airco buitenunits op een dakproject",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605462/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605462128.jpg",
      alt: "Onderhoud en inspectie van een airco-installatie",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605462/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605462569.jpg",
      alt: "Warmtepompinstallatie bij een woning",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605654/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605654307.jpg",
      alt: "Zonnepanelen met Panasonic buitenunit op een dak",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605654/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605654481.jpg",
      alt: "Technische leidingwerk installatie en verwarmingssysteem",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605654/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605654271.jpg",
      alt: "Moderne zwarte airco binnenunit",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773605655/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773605655470.jpg",
      alt: "Laadpaal project op locatie",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773606957/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773606957668.jpg",
      alt: "Grote Mitsubishi installatie op projectlocatie",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773607217/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773607216907.jpg",
      alt: "Panasonic airco binnenunit onder een raam",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773607404/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773607404649.jpg",
      alt: "Projectfoto met Spiro tussen meerdere buitenunits op het dak",
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773607398/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773607398080.jpg",
      alt: "Open cv-ketel of verwarmingssysteem tijdens installatie of service",
    },
  ];

  return (
    <div className="pt-24 pb-20">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-bold mb-6">Onze Projecten</h1>
          <p className="text-xl text-gray-600">
            Een beeld van ons vakmanschap. Van strakke wandunits in moderne woonkamers tot complexe technische installaties op bedrijfspanden.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 md:columns-3 gap-4 space-y-4 mb-20 max-w-7xl mx-auto">
          {collageImages.map((img, idx) => (
            <div
              key={idx}
              className="break-inside-avoid relative group rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700 ease-in-out"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white font-medium p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  {img.alt}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl mb-20 relative overflow-hidden border border-gray-800">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-500 rounded-full blur-3xl opacity-20 -mr-20 -mt-20" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-orange-500 via-pink-500 to-purple-600 rounded-full blur-3xl opacity-20 -ml-20 -mb-20" />

          <div className="relative z-10 flex flex-col items-center">
            <div className="bg-gradient-to-tr from-orange-500 via-pink-500 to-purple-600 p-4 rounded-2xl mb-6 shadow-lg shadow-pink-500/20">
              <Instagram className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-3xl font-bold mb-4">Volg onze allernieuwste projecten op Instagram</h2>
            <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
              Kijk mee achter de schermen, zie onze nieuwste installaties en blijf op de hoogte van handige tips en acties.
            </p>
            <Button size="lg" asChild className="bg-white hover:bg-gray-100 text-gray-900 font-bold px-8 rounded-full shadow-xl hover:scale-105 transition-all duration-300">
              <a href="https://www.instagram.com/spirotechniekbv/" target="_blank" rel="noopener noreferrer">
                Volg @spirotechniekbv
              </a>
            </Button>
          </div>
        </div>

        <div className="bg-gray-50 rounded-3xl p-12 text-center border border-gray-100 relative overflow-hidden">
          <div className="relative z-10">
            <h2 className="text-3xl font-bold mb-4 text-gray-900">Overtuigd van onze kwaliteit?</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">Wij komen graag bij u langs om te kijken wat er mogelijk is in uw situatie.</p>
            <Button size="lg" asChild className="bg-orange-600 hover:bg-orange-700 text-white font-bold px-10 shadow-lg">
              <Link to="/offerte">Vraag offerte aan</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
